import {useEffect} from 'react';
import {UserFlowStep} from '../../Facade/UserFlow/BaseUserFlow';
import APIServer from '@taopix/taopix-core/dist/types/Service/APIServer';
import {useUserFlowState} from '../../Components/Context/UserFlow/UserFlowContext';
import {useUiState} from '../../Components/Context/UserInterface/UserInterfaceContext';
import {useTaopix} from '../../Components/Context/TaopixContext';
import {useErrorBoundary} from 'react-error-boundary';
import {UserFlowType} from '../../Facade/UserFlow/UserFlowFacade';

export const useFlightCheckObserver = (server: APIServer) => {
  const app = useTaopix();
  const ui = useUiState();
  const userFlow = useUserFlowState();
  const {showBoundary} = useErrorBoundary();

  const currentStep = userFlow.isStepActive(
    UserFlowType.FlightCheck,
    UserFlowStep.FlightCheckInitialise
  );

  useEffect(() => {
    let controller;

    if (currentStep && !ui.state.busy) {
      controller = new AbortController();
      // server call to do flightcheck
      app.core
        .get('stateManager')
        .call('flightcheck')
        .then(response => {
          if (
            response?.flightcheck &&
            Object.keys(response?.flightcheck.minorErrors).length === 0 &&
            Object.keys(response?.flightcheck.criticalErrors).length === 0
          ) {
            userFlow.setNextStep();
          } else {
            userFlow.setCurrentStep(
              `${UserFlowStep.FlightCheck}.${UserFlowStep.FlightCheckReview}`
            );
          }
        })
        .catch(error => {
          userFlow.setCurrentStep(`${UserFlowType.FlightCheck}.${UserFlowStep.None}`);
          if (server.isCancel(error)) return;
          showBoundary(error);
        });
    }

    return () => {
      if (controller instanceof AbortController && !ui.state.busy) {
        controller.abort();
      }
    };
  }, [currentStep, ui.state.busy]);
};
